/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Acrobat_PriceInputs */

const en_pc_alt_t_acrobat_price = /** @type {(inputs: Pc_Alt_T_Acrobat_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader is free. Standard, Pro and Studio cost US$14.99, US$19.99 and US$24.99 a month on an annual plan`)
};

const zh_pc_alt_t_acrobat_price = /** @type {(inputs: Pc_Alt_T_Acrobat_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader 免费。Standard、Pro、Studio 按年订阅时分别为每月 14.99、19.99、24.99 美元`)
};

/**
* | output |
* | --- |
* | "Reader is free. Standard, Pro and Studio cost US$14.99, US$19.99 and US$24.99 a month on an annual plan" |
*
* @param {Pc_Alt_T_Acrobat_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_acrobat_price = /** @type {((inputs?: Pc_Alt_T_Acrobat_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Acrobat_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_acrobat_price(inputs)
	return zh_pc_alt_t_acrobat_price(inputs)
});
export { pc_alt_t_acrobat_price as "pc.alt.t.acrobat.price" }